import { WorkspacesListPanel } from 'src/applications/Oversight/panels/Concierge/WorkspacesListPanel'
import { ContentArea } from 'src/resources/layouts/ContentArea'

export const WorkspacesListScene = () => (
  <ContentArea>
    <WorkspacesListPanel />
  </ContentArea>
)
